import React from "react";

export const Logo = ({ className = "", variant = "auto" }) => {
  const textCls =
    variant === "light"
      ? "text-white"
      : variant === "dark"
      ? "text-slate-900"
      : "text-slate-900 dark:text-white";

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img 
        src="/Logo (scaleable).svg" alt="SolkSites logo" className="h-[30px] w-[30px]" 
      />
      <span className={`font-extrabold tracking-tight text-lg ${textCls}`}>
        SolkSites
      </span>
    </div>
  );
};

export default Logo;
